import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { Information, MenuItem } from '@model';
import { SubSink } from 'subsink';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromInformationStore from '@core/store';
import * as fromConfigurationStore from '@appStore/configuration';
import { switchMap, map, filter, take } from 'rxjs/operators';
import { NodeType } from '@enums';

@Component({
    selector: 'app-epi-content',
    templateUrl: './epi-content.component.html',
    standalone: false
})
export class EpiContentComponent implements OnInit, OnDestroy {
  epiContent$: Observable<Information>;

  private subs = new SubSink();
  epiPageRoute: string;
  epiPageId: number;
  private parametersObservable$: any;
  node: MenuItem;

  constructor(
    private informationStore: Store<fromInformationStore.InformationState>,
    private configurationStore: Store<fromConfigurationStore.State>,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {
    this.parametersObservable$ = this.route.params.subscribe(params => {
      this.epiPageRoute = params.epiPageRoute ? params.epiPageRoute : null;
    });

    if (this.router.url !== '' && this.epiPageRoute) {
      this.subs.sink = this.configurationStore
        .select(fromConfigurationStore.getMenuConfigurationLoaded)
        .pipe(
          filter(x => !!x),
          take(1),
          switchMap(_ => this.configurationStore.select(fromConfigurationStore.getMenuConfiguration))
        )
        .subscribe(nodes => {
          // recursivly get menu node
          this.getEpiContentNode(nodes, this.epiPageRoute);
          if (this.node) {
            // Fetch Epi Page
            this.epiContent$ = this.informationStore.select(fromInformationStore.getInformation).pipe(
              map(informationStructure => {
                let page = informationStructure.informations.find(
                  informationPage => informationPage.id === parseInt(this.node.epiPageId, 10)
                );
                return page;
              })
            );
          }
        });
    }

    // if (this.router.url !== '' && this.epiPageRoute) {
    //   this.epiContent$ = this.route.params.pipe(
    //     switchMap(params => {
    //       return this.informationStore.select(fromInformationStore.getInformation).pipe(
    //         map(informationStructure => {
    //           let page = informationStructure.informations.find(
    //             informationPage => informationPage.id === this.epiPageId
    //           );
    //           return page;
    //         })
    //       );
    //     })
    //   );
    // }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();

    if (this.parametersObservable$ != null) {
      this.parametersObservable$.unsubscribe();
    }
  }

  getEpiContentNode(nodes: MenuItem[], epiPageRoute: string): MenuItem {
    if (!nodes || nodes.length === 0) {
      return;
    }
    this.recursivlyFindNode(epiPageRoute, NodeType.Epi, nodes);
  }

  recursivlyFindNode(epiPageRoute: string, nodeType: NodeType, nodes: MenuItem[]) {
    if (nodes !== null && nodes.length !== 0) {
      nodes.forEach(n => {
        if (n.nodeType === nodeType && n.epiPageRoute === epiPageRoute) {
          this.node = n;
        } else if (n.children && n.children.length > 0) {
          this.recursivlyFindNode(epiPageRoute, NodeType.Epi, n.children);
        }
      });
    }
  }
}
